import React from "react";
import style from "./choose-invite-type-modal.module.css";
import StyledButton, { ButtonStyle } from "frontend/ui-components/styled-button";
import { CloseIcon } from "frontend/ui-components/svg-shapes";

const BUTTON_STYLES = {
  height: "40px",
  width: "216px",
  strokeWidth: "1.5px",
  stroke: "#1973FF",
  borderRadius: "6px",
  fontFamily: "Poppins",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "normal",
};

export default function ChooseInviteTypeModal({
  unsubscribed,
  setShouldRenderUnsubscribedModal,
  setAddAsRestricted,
  onDismiss,
}: {
  unsubscribed: string[] | null;
  setShouldRenderUnsubscribedModal: (shouldRender: boolean) => void;
  setAddAsRestricted: (addAsRestricted: boolean) => void;
  onDismiss: () => void;
}) {
  return (
    <div className={style.container}>
      <div style={{ position: "relative" }} className={style.closeIcon}>
        <CloseIcon
          onClick={onDismiss}
          color={"#848199"}
          style={{
            zIndex: 9999,
          }}
        />
      </div>
      <div className={style.header}>
        <span className={style.title}>{`Almost there...`}</span>
      </div>
      <div className={style.content}>
        <span>{`These users don’t have a WorkCanvas seat and will be added as viewers. Want to give them edit access instead? (This will use a seat.)`}</span>
        <div className={style.unsubscribedList}>
          {unsubscribed?.map((email) => (
            <div key={email} className={style.unsubscribedItem}>
              <span>{email}</span>
            </div>
          ))}
        </div>
        <div className={style.buttonsContainer}>
          <StyledButton
            title={"Add as viewers only"}
            style={ButtonStyle.outline}
            onClick={() => {
              setShouldRenderUnsubscribedModal(false);
              setAddAsRestricted(true);
            }}
            customStyle={{ ...BUTTON_STYLES, color: "#1973FF" }}
          />
          <StyledButton
            title={"Add with edit access"}
            onClick={() => {
              setShouldRenderUnsubscribedModal(false);
              setAddAsRestricted(false);
            }}
            customStyle={{ ...BUTTON_STYLES, color: "white" }}
          />
        </div>
      </div>
    </div>
  );
}
